import moment from "moment";
import {auth} from "./auth";
import { api } from './api'

let bulkAddEventListener = (object, events, callback) => {
  events.forEach(event => {
    object.addEventListener(event, (event) => {
      callback(event)
    })
  })
};


export class SessionTracker {
  constructor() {
    let expiresIn = localStorage.getItem('expires_in')
    this.settings = {
      expiresIn: expiresIn ? expiresIn : null,
      idleLifetime: 300000,
      beforeTokenExpiration: null,
      logout: null,
      events: ['mousemove', 'keydown', 'mousedown', 'touchstart', 'scroll'],
      isAlive: true,
    };
    this.tokenTimer = null;
    this.idleTimer = null;
  }

  setTokenLifetime(expires_in) {
    this.settings.expiresIn = expires_in;
    localStorage.setItem('expires_in', this.settings.expiresIn)
    clearTimeout(this.tokenTimer);
    this.startTokenLifetime(expires_in)
  }

  resetIdleLifetime() {
    clearTimeout(this.idleTimer);
    this.startIdleLifetime();
  }

  isExpired() {
    const currentTime = moment().unix();
    return currentTime > this.settings.expiresIn
  }

  startTokenLifetime(expires) {
    if(expires) {
      this.tokenTimer = setTimeout(() => {
        if (auth.isAuthenticated()) {
          api.refreshToken();
        }
      }, (expires - moment().unix()) * 1000);
    }
  }

  startIdleLifetime() {
    this.idleTimer = setTimeout(() => {
      this.settings.isAlive = false;
      if (this.settings.logout) this.settings.logout();
    }, this.settings.idleLifetime);
  };

  start(expires) {
    this.settings.isAlive = true;
    this.startIdleLifetime();
    bulkAddEventListener(window, this.settings.events, () => {
      if (this.settings.isAlive) {
        this.resetIdleLifetime();
      }
    });
    this.startTokenLifetime(expires);
  };

  stop() {
    this.settings.isAlive = false;
    clearTimeout(this.tokenTimer);
    clearTimeout(this.idleTimer);
  }

  configure(options) {
    this.settings = Object.assign({}, this.settings, options);
  };
}

export const InitSession = new SessionTracker();
